const partialCheckbox = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsCheckbox.hbs');
const general_utils = require('civicsUtils/general_utilities');

define(function (require) {

	var getCheckBox = function (ele, readOnlyForm, detailOptions) {
		var customData =  "specialType = \"" + ele.specialType + "\"";
		// Building checkbox
		var checkboxData = {
			id: ele.id,
			text:(ele.specialType == 'grid') ? '' : ele.text,
			classes: ele.isVisible === false ? 'hidden checkbox-container':'checkbox-container',
			name: ele.bind ? ele.bind : ele.id,
			disabled: (readOnlyForm || ele.isEnabled === false),
			required:ele.isRequired,
			checked: (ele.value && ( ele.value.toString().toUpperCase() === 'TRUE' || ele.value.toString().toUpperCase() === 'YES')),
			customAttr: customData,
			hideRequired: ele.specialType == 'grid' ? true : false,
		};
		if ( ele.description )
		{
			checkboxData.tooltip = general_utils.attributeEscapeString(ele.description);
		}

		return partialCheckbox($.extend({}, checkboxData));
	};

	return {
		getCheckBox: function(ele, readOnlyForm, detailOptions) {
			return getCheckBox(ele, readOnlyForm, detailOptions);
		}
	}
});